import React from 'react';
import { Box, Button, Stack } from '@mui/material';
import { Apple as AppleIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { APP_STORE_URL, PLAY_STORE_URL } from '../config/marketingEvents';

const PLAY_ICON =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23F7F1E8' d='M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z'/%3E%3C/svg%3E";

const defaultBtnSx = {
  background: 'rgba(18,5,8,0.35)',
  color: '#F7F1E8',
  border: '1px solid rgba(201,169,97,0.5)',
  borderRadius: 0,
  fontSize: 11,
  letterSpacing: '0.13em',
  textTransform: 'uppercase',
  px: 1.75,
  py: 1,
  minWidth: 0,
  boxShadow: 'none',
  backdropFilter: 'blur(3px)',
  '&:hover': {
    background: 'rgba(201,169,97,0.16)',
    boxShadow: 'none',
  },
};

const AppStoreBadges = ({ buttonSx }) => {
  const { t } = useTranslation();
  const sx = { ...defaultBtnSx, ...buttonSx };

  return (
    <Stack
      direction="row"
      spacing={1.25}
      useFlexGap
      flexWrap="wrap"
      alignItems="center"
      data-testid="app-store-badges"
    >
      <Button
        component="a"
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        startIcon={
          <Box component="img" src={PLAY_ICON} alt="" sx={{ width: 18, height: 18 }} />
        }
        sx={sx}
      >
        {t('home.footer.googlePlay')}
      </Button>
      <Button
        component="a"
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        startIcon={<AppleIcon sx={{ fontSize: 18 }} />}
        sx={sx}
      >
        {t('home.footer.appStore')}
      </Button>
    </Stack>
  );
};

export default AppStoreBadges;
